import type { PostPutBrandTranslationAdminEntity } from './PostPutBrandTranslationAdminEntity'

export class BrandEntity {
  id?: number
  translations?: Array<PostPutBrandTranslationAdminEntity> | null
  coverImageUrl?: string | null
  profileImageUrl?: string | null
  distanceCapInKm?: number | null
}
